import { render, staticRenderFns } from "./mm-header.vue?vue&type=template&id=04e44ae6&"
import script from "./mm-header.vue?vue&type=script&lang=js&"
export * from "./mm-header.vue?vue&type=script&lang=js&"
import style0 from "./mm-header.vue?vue&type=style&index=0&id=04e44ae6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports